import { useContext, useEffect, useRef } from 'react';
import { useMutation } from '@apollo/react-hooks';

import widgetSessionOpenedMutation from './WidgetSessionOpenedMutation.graphql';
import { DILM_CLIENT_CONTEXT } from '../../shared/constants';
import { SchedulingSessionStateContext } from '../../shared/components/SchedulingSessionState';

interface IProps {
  widgetId?: string;
  setCalled: Function;
  called: boolean;
}

export default function WidgetSessionOpenedMutation({ widgetId, setCalled, called }: IProps) {
  const mutationCalledRef = useRef(false);
  const { widgetSessionOpenedTracked, setWidgetSessionOpenedTracked } = useContext(
    SchedulingSessionStateContext
  );
  const [widgetSessionOpened] = useMutation(widgetSessionOpenedMutation, {
    variables: { widgetId },
    context: DILM_CLIENT_CONTEXT,
  });

  useEffect(() => {
    if (widgetId && !widgetSessionOpenedTracked && !called && !mutationCalledRef.current) {
      widgetSessionOpened()
        .then(() => {
          setWidgetSessionOpenedTracked(true);
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log('Error With the `widgetSessionOpened` mutation', error);
        });
      mutationCalledRef.current = true;
      setCalled(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
